module.exports = __webpack_public_path__ + "img/img_28.f761ee6d.jpg";